export const CREATE_PRICE_PUBLISHED_ROWS_STORAGE_KEY =
  'createPricePublishedRows';
